"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rm = exports.whoami = exports.printenv = exports.echo = exports.pwd = exports.cd = exports.mkdir = exports.cat = exports.ls = exports.clear = exports.help = void 0;
var Util = __importStar(require("./util.js"));
var const_1 = require("./const");
var helpCommands = ['clear', 'ls', 'cat', 'mkdir', 'cd', 'pwd', 'echo', 'printenv', 'whoami', 'rm'];
exports.help = {
    exec: function (state) {
        var _a;
        return Object.assign({}, state, {
            history: (_a = state.history).concat.apply(_a, __spreadArrays([{ value: 'React-bash:' },
                { value: 'These shell commands are defined internally.  Type \'help\' to see this list.' }], helpCommands.map(function (value) { return ({ value: value }); }))),
        });
    },
};
exports.clear = {
    exec: function (state) {
        return Object.assign({}, state, { history: [] });
    },
};
exports.ls = {
    exec: function (state, _a) {
        var flags = _a.flags, args = _a.args;
        var path = args[0] || '';
        var fullPath = Util.extractPath(path, state.cwd);
        var _b = Util.getDirectoryByPath(state.structure, fullPath), err = _b.err, dir = _b.dir;
        if (err) {
            return Util.appendError(state, err, path);
        }
        else {
            var content = Object.keys(dir);
            if (!flags.a) {
                content = content.filter(function (name) { return name[0] !== '.'; });
            }
            if (flags.l) {
                return Object.assign({}, state, {
                    history: state.history.concat(content.map(function (value) {
                        return { value: value };
                    })),
                });
            }
            else {
                return Object.assign({}, state, {
                    history: state.history.concat({ value: content.join(' ') }),
                });
            }
        }
    },
};
exports.cat = {
    exec: function (state, _a) {
        var args = _a.args;
        var path = args[0];
        var relativePath = path.split('/');
        var fileName = relativePath.pop();
        var fullPath = Util.extractPath(relativePath.join('/'), state.cwd);
        var _b = Util.getDirectoryByPath(state.structure, fullPath), err = _b.err, dir = _b.dir;
        if (err) {
            return Util.appendError(state, err, path);
        }
        else if (!dir[fileName]) {
            return Util.appendError(state, const_1.Errors.NO_SUCH_FILE, path);
        }
        else if (!dir[fileName].hasOwnProperty('content')) {
            return Util.appendError(state, const_1.Errors.IS_A_DIRECTORY, path);
        }
        else {
            var content = dir[fileName].content.replace(/\n$/, '');
            var lines = content.split('\n').map(function (value) { return ({ value: value }); });
            return Object.assign({}, state, {
                history: state.history.concat(lines),
            });
        }
    },
};
exports.mkdir = {
    exec: function (state, _a) {
        var args = _a.args;
        var path = args[0];
        var relativePath = path.split('/');
        var newDirectory = relativePath.pop();
        var fullPath = Util.extractPath(relativePath.join('/'), state.cwd);
        var deepCopy = JSON.parse(JSON.stringify(state.structure));
        var dir = Util.getDirectoryByPath(deepCopy, fullPath).dir;
        if (dir[newDirectory]) {
            return Util.appendError(state, const_1.Errors.FILE_EXISTS, path);
        }
        else {
            dir[newDirectory] = {};
            return Object.assign({}, state, { structure: deepCopy });
        }
    },
};
exports.cd = {
    exec: function (state, _a) {
        var args = _a.args;
        var path = args[0];
        if (!path || path === '/') {
            return Object.assign({}, state, { cwd: '' });
        }
        var fullPath = Util.extractPath(path, state.cwd);
        var err = Util.getDirectoryByPath(state.structure, fullPath).err;
        if (err) {
            return Util.appendError(state, err, path);
        }
        else {
            return Object.assign({}, state, { cwd: fullPath });
        }
    },
};
exports.pwd = {
    exec: function (state) {
        var directory = "/" + state.cwd;
        return Object.assign({}, state, {
            history: state.history.concat({ value: directory }),
        });
    },
};
exports.echo = {
    exec: function (state, _a) {
        var input = _a.input;
        var ECHO_LENGTH = 'echo '.length;
        var envVariables = Util.getEnvVariables(state);
        var value = input.slice(ECHO_LENGTH).replace(/(\$\w+)/g, function (key) {
            return envVariables[key.slice(1)] || '';
        });
        return Object.assign({}, state, {
            history: state.history.concat({ value: value }),
        });
    },
};
exports.printenv = {
    exec: function (state) {
        var envVariables = Util.getEnvVariables(state);
        var values = Object.keys(envVariables).map(function (key) {
            return { value: key + "=" + envVariables[key] };
        });
        return Object.assign({}, state, {
            history: state.history.concat(values),
        });
    },
};
exports.whoami = {
    exec: function (state) {
        var value = state.settings.user.username;
        return Object.assign({}, state, {
            history: state.history.concat({ value: value }),
        });
    },
};
exports.rm = {
    exec: function (state, _a) {
        var flags = _a.flags, args = _a.args;
        var path = args[0];
        var relativePath = path.split('/');
        var file = relativePath.pop();
        var fullPath = Util.extractPath(relativePath.join('/'), state.cwd);
        var deepCopy = JSON.parse(JSON.stringify(state.structure));
        var dir = Util.getDirectoryByPath(deepCopy, fullPath).dir;
        if (dir[file]) {
            // folder deletion requires the recursive flags `-r` or `-R`
            if (!Util.isFile(dir[file]) && !(flags.r || flags.R)) {
                return Util.appendError(state, const_1.Errors.IS_A_DIRECTORY, path);
            }
            delete dir[file];
            return Object.assign({}, state, { structure: deepCopy });
        }
        else {
            return Util.appendError(state, const_1.Errors.NO_SUCH_FILE, path);
        }
    },
};
//# sourceMappingURL=commands.js.map